module.exports = __webpack_public_path__ + "static/img/n-one.71dc865f.png";